import { render, staticRenderFns } from "./FilterSizes.vue?vue&type=template&id=16621bb9&"
import script from "./FilterSizes.vue?vue&type=script&lang=js&"
export * from "./FilterSizes.vue?vue&type=script&lang=js&"
import style0 from "./FilterSizes.vue?vue&type=style&index=0&id=16621bb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports